module.exports = __webpack_public_path__ + "u0bwr3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ranks/18.jpg
// module id = 546
// module chunks = 1